// extracted by mini-css-extract-plugin
export var actionButton = "_c7-5";
export var actionButtonActive = "_c7-6";
export var content = "_c7-3";
export var header = "_c7-4";
export var list = "_c7-7";
export var settingsContent = "_c7-a";
export var settingsPanel = "_c7-b";
export var settingsRow = "_c7-c";
export var state = "_c7-9";
export var triggerBadge = "_c7-2";
export var triggerButton = "_c7-1";
export var triggerShell = "_c7-0";
export var unreadDot = "_c7-8";